import axios from "axios";
import apolloClient from "../apolloClient";
import { GET_STORE } from "./graphql";

const endpoint = "/users/v1/auth";
class StoreService {
	async fetch() {
		const { data } = await apolloClient.query({
			query: GET_STORE,
		});
		return data.shop;
	}

	async login(appKey) {
		const response = await axios.post(`${endpoint}/app/login`, { appKey });
		const { data } = response;
		this.setSession(data.accessToken);
		return data;
	}

	setSession = (access_token) => {
		if (access_token) {
			sessionStorage.setItem("corksy_store_access_token", access_token);
			axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
		} else {
			sessionStorage.removeItem("corksy_store_access_token");
			delete axios.defaults.headers.common.Authorization;
		}
	};
}

export default new StoreService();
